import { Button } from "@majitap/ui";
import { Dialog, DialogContent } from "@majitap/ui/arc/dialog/dialog";
import { useState } from "react";
import styles from "../customers/customers.module.css";
import { type Payer, PayerPicker } from "../invoices/payer";

/** Narrow a list to one customer or one business, found by search (orders, pricing rules). */
export function PayerFilterDialog({
  title,
  description,
  action,
  onPick,
  onClose,
}: {
  title: string;
  description: string;
  action: string;
  onPick: (payer: Payer) => void;
  onClose: () => void;
}) {
  const [payer, setPayer] = useState<Payer | null>(null);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent title={title} description={description}>
        <div className={styles.form}>
          <PayerPicker label="Whose" value={payer} onChange={setPayer} />
          <div className={styles.footer}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button disabled={!payer} onClick={() => payer && onPick(payer)}>
              {action}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
